import { gql } from "@apollo/client";

const UPDATE_TAX_INFO = gql`
  mutation updateTaxInfo($input: TaxInfo) {
    updateTaxInfo(input: $input) {
      data
      status
      error
    }
  }
`;

export default UPDATE_TAX_INFO;
